var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowBack = function SvgArrowBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5575 10.6065C22.4593 10.5905 22.3599 10.5832 22.2604 10.5845H5.32893L5.69812 10.4128C6.059 10.242 6.38731 10.0095 6.66833 9.72588L11.4164 4.97786C12.0417 4.38092 12.1468 3.42064 11.6653 2.70259C11.1051 1.93742 10.0306 1.77128 9.26537 2.33157C9.20355 2.37686 9.14479 2.42623 9.08957 2.47935L0.503632 11.0653C-0.167358 11.7355 -0.167949 12.8228 0.502291 13.4938C0.50272 13.4942 0.503203 13.4947 0.503632 13.4951L9.08957 22.081C9.7611 22.7507 10.8483 22.7492 11.518 22.0777C11.5707 22.0248 11.62 21.9686 11.6653 21.9093C12.1468 21.1913 12.0417 20.231 11.4164 19.6341L6.67692 14.8774C6.42498 14.6252 6.13531 14.4138 5.81833 14.2507L5.30317 14.0189H22.1659C23.0432 14.0514 23.8128 13.4387 23.9776 12.5764C24.1294 11.6403 23.4936 10.7583 22.5575 10.6065Z",
    fill: "#13327C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowBack.82d24ed0.svg";
export { ForwardRef as ReactComponent };